export default "__VITE_ASSET__CpIrNYOM__"